module.exports = __webpack_public_path__ + "static/media/7_r_stol_86.51_67.78.41f8b2a0.png";